module.exports = __webpack_public_path__ + "img/internews-logo.a12c1dbf.png";